import React, { useEffect, useState } from "react";
import useSave from "../../Hooks/useSave";
import useFetch from "../../Hooks/useFetch";
import useDelete from "../../Hooks/useDelete";
import Table from "./../../Components/Table";
import { Link } from "react-router-dom";
import Modal from "react-awesome-modal";
import Api from "../../Hooks/Api";
const PerformanceContracting = (props) => {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [view, setview] = useState(false);
  const [staffOptions, setStaffOptions] = useState([]);
  const [yearsOptions, setyearsOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([
    { name: "Open" },
    { name: "Active" },
  ]);
  const [update, setUpdate] = useState(false);
  const url = "api/contracts";
  const { state, FetchAll } = useFetch(url);

  const fetchStaff = async () => {
    try {
      Api.get("/api/staff")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setStaffOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const fetchFinancialYear = async () => {
    try {
      Api.get("/api/financial-years")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setyearsOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };

  useEffect(() => {
    FetchAll();
    fetchFinancialYear();
    fetchStaff();
  }, []);

  const handleOpenModal = (event) => {
    event.persist();
    setInputs({});
    setOpen(true);
  };

  const handleInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const handleEdit = () => {
    if (inputs.contractId) {
      setOpen(true);
      setUpdate(true);
      setview(false);
    } else {
      alert("Select a record to edit");
    }
  };
  const handleView = () => {
    if (inputs.contractId) {
      setview(true);
      setUpdate(false);
      setOpen(true);
    } else {
      alert("Select a record to veiw");
    }
  };
  const handleSelect = (k, event) => {
    setInputs({});
    setInputs(k);
  };
  const handleCloseModal = () => {
    setOpen(false);
    setview(false);
  };

  const HandleSubmit = (event) => {
    event.preventDefault();

    useSave(url, inputs);
  };
  const CallDeletehook = () => {
    useDelete(url + "/delete?id=" + inputs.contractId);
  };
  const HandelDelete = () => {
    if (inputs.contractId) {
      CallDeletehook();
    } else {
      alert("Select a record to delete");
    }
  };
  const ColumnData = [
    {
      label: "Id",
      field: "contractId",
      sort: "asc",
    },
    {
      label: "Financial Year",
      field: "financialYear",
      sort: "asc",
    },
    {
      label: "Staff",
      field: "staff",
      sort: "asc",
    },
    {
      label: "Status",
      field: "status",
      sort: "asc",
    },
  ];
  let Rowdata1 = [];
  const rows = state.data;
  if (rows.length > 0) {
    rows.forEach((k) => {
      const Rowdata = {
        clickEvent: () => handleSelect(k),
        financialYear: k.financialYear ? k.financialYear.name : "N/A",
        staff: k.staff ? k.staff.fullName : "N/A",
        contractId: k.contractId,
        status: k.status,
      };
      Rowdata1.push(Rowdata);
    });
  }
  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active"> Performance Contract</li>
      </ol>
      <h1 class="page-header mb-3"> Performance Contract</h1>
      <div style={{ backgroundColor: "white" }}>
        <div className="row">
          <div class="col-sm-12 d-flex flex-row float-right">
            &nbsp; &nbsp; &nbsp;
            <button
              onClick={handleOpenModal}
              className="btn btn-primary p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              New
            </button>
            <button
              onClick={handleView}
              className="btn btn-success p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              View
            </button>
            <button
              onClick={handleEdit}
              className="btn btn-info p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              Edit
            </button>
            <button
              onClick={HandelDelete}
              className="btn btn-danger p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              Delete
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <Table Rows={Rowdata1} columns={ColumnData} />
          </div>
        </div>
      </div>

      <Modal visible={open} width="50%" height="70%" effect="fadeInUp">
        <div style={{ "overflow-y": "auto", height: "100%" }}>
          <a className="close" onClick={() => handleCloseModal()}>
            &times;
          </a>

          <div className="row">
            <div className="col-sm-5"></div>
            {view ? null : (
              <div className="col-sm-4 fontWeight-bold text-blue">
                Performance Contract
              </div>
            )}
          </div>
          <div className="container-fluid">
            <div className="col-sm-12">
              <div className="ibox-content">
                <br />

                {view ? (
                  <div>
                    <h3> Performance Contract</h3>
                    <table className="table table-sm">
                      <tbody>
                        <tr>
                          <td className="font-weight-bold">Status:</td>
                          <td>{inputs.status}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Staff:</td>
                          <td>{inputs.staff ? inputs.staff.fullName : ""}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Financial Year:</td>
                          <td>
                            {inputs.financialYear
                              ? inputs.financialYear.name
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    <div className="row">
                      <div class="d-flex flex-row ">
                        <button
                          className="btn btn-primary p-2"
                          type="button"
                          onClick={handleEdit}
                        >
                          Update
                        </button>
                        &nbsp;
                        <button
                          onClick={HandelDelete}
                          className="btn btn-danger p-2"
                        >
                          Delete
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-warning p-2"
                          type="button"
                          onClick={handleCloseModal}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                    <br />
                  </div>
                ) : (
                  <form className="form-horizontal" onSubmit={HandleSubmit}>
                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Staff
                          </label>
                          <select
                            className="form-control"
                            name="staffId"
                            required
                            value={inputs.staffId || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select staff</option>
                            {staffOptions &&
                              staffOptions.map((types) => (
                                <option
                                  key={types.staffId}
                                  value={types.staffId}
                                >
                                  {types.fullName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Financial year
                          </label>
                          <select
                            className="form-control"
                            name="financialYearId"
                            required
                            value={inputs.financialYearId || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select year</option>
                            {yearsOptions &&
                              yearsOptions.map((types) => (
                                <option key={types.id} value={types.id}>
                                  {types.name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Status
                          </label>
                          <select
                            className="form-control"
                            name="status"
                            required
                            value={inputs.status || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select status</option>
                            {statusOptions &&
                              statusOptions.map((types) => (
                                <option key={types.name} value={types.name}>
                                  {types.name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm">
                        <div className="row">
                          <div className="col-sm-12">
                            <div class="d-flex flex-row">
                              {update ? (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Update
                                </button>
                              ) : (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Submit
                                </button>
                              )}
                              &nbsp;
                              <button
                                className="btn btn-warning p-2"
                                type="button"
                                onClick={handleCloseModal}
                              >
                                Close
                              </button>
                            </div>
                            <br />
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default PerformanceContracting;
